import { Link, navigate } from 'gatsby'
import React, { useEffect, useState } from 'react'
import * as PopupStyles from './Popup.module.scss'

interface IPopup {
  setPopup: React.Dispatch<React.SetStateAction<boolean>>
  siteId?: number
}

const Popup = ({ setPopup, siteId }: IPopup) => {
  const [typedText, setTypedText] = useState<string>('')
  const popupImg = '/images/popup-img.jpg'
  // const popupImg = '/images/awards/Leader_2023.jpg'
  // const [popupImg, setPopupImg] = useState<string>(
  //   '/images/awards/Leader_2023.jpg'
  // )
  const [emailAddress, setEmailAddress] = useState<string | null>(null)
  const [touched, setTouched] = useState<boolean>(false)

  const Write = (letters: string[], i: number, l: number) => {
    const newIterator = i + 1
    setTypedText(letters.slice(0, newIterator).join(''))
    setTimeout(() => {
      if (newIterator <= l) Write(letters, newIterator, l)
    }, 100)
    return i++
  }

  const submitPopup = () => {
    setPopup(false)
    navigate(`/sign-up${emailAddress && '?email=' + emailAddress}`)
  }

  const handleInputChange = (val: string) => {
    setEmailAddress(val)
    val.length ? setTouched(true) : setTouched(false)
  }

  const setupTypewriter = (text: string) => {
    const letters = text.split('')
    const l = letters.length
    Write(letters, 0, l)
  }

  const visitLogin = () => {
    setPopup(false)
    navigate(`/log-in`)
  }

  useEffect(() => {
    // if (siteId === 6 || siteId === 16) {
    //   setPopupImg('/images/nlr-popup-img.png')
    // }
    document
      .getElementsByTagName('body')[0]
      .classList.add(PopupStyles.BodyLocked)
    // setupTypewriter('The Muddy Awards are go!');
    setupTypewriter('Get Muddy!')
    return () =>
      document
        .getElementsByTagName('body')[0]
        .classList.remove(PopupStyles.BodyLocked)
  }, [])

  return (
    <div className={PopupStyles.ClickGuard}>
      <div className={PopupStyles.Wrapper}>
        <button
          title={`Dismiss this popup for 48 hours`}
          className={PopupStyles.CloseButton}
          onClick={() => setPopup(false)}
        />
        <div className={PopupStyles.Cols}>
          <div className={PopupStyles.Img}>
            <img src={popupImg} />
            {/* <img src='/images/awards/Leader_2023.jpg' />
                <img src='/images/awards/inlovewithlocal.png' className={PopupStyles.Absolute} /> */}
          </div>
          <div className={PopupStyles.TextContent}>
            <div className={PopupStyles.Stretch}>
              <p className={PopupStyles.Typewriter}>{typedText}</p>
              <p className={PopupStyles.NormalText}>
                {siteId === 6 || siteId === 16 ? (
                  <>Double the fun, coming soon!</>
                ) : (
                  <>What’s On | Culture | Eat | Shop | Kids | Lifestyle</>
                )}
              </p>
              {/* <p className={PopupStyles.NormalText}>Nominate your favourite local indie business now!</p> */}
              <p className={PopupStyles.NormalText}>
                <em>
                  {siteId === 6 || siteId === 16 ? (
                    <>
                      Sign up to Northants, Leics & Rutland free newsletter to
                      get more from where you live.
                    </>
                  ) : (
                    <>
                      Sign up to our free newsletter to get more from where you
                      live.
                    </>
                  )}
                </em>
              </p>
              <div
                className={`${PopupStyles.Form} ${
                  touched && PopupStyles.Touched
                }`}
              >
                <input
                  type="text"
                  name="emailAddress"
                  onChange={e => handleInputChange(e.target.value)}
                  defaultValue=""
                  placeholder="Enter your email address"
                />
                <button onClick={submitPopup} className={PopupStyles.Button}>
                  Sign Up
                </button>
              </div>
              <p className={PopupStyles.SmallText}>
                Already signed up?{' '}
                <span className={PopupStyles.Link} onClick={visitLogin}>
                  Log in
                </span>{' '}
                save your favourites.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Popup
